export function hasRolePermission(role: string): boolean {
  const roles: string | null = localStorage.getItem('roles');
  if (!roles) {
    return false;
  }
  return roles.includes(role);
}

export function getLocationTypes(): string[] {
  return ['', 'PLANT', 'SITE'];
}

export function mapLanguageCode(languageCode): string {
  const languageMap = {
    en: 'English (US)',
    it: 'Italian',
    fr: 'French',
    pt: 'Portuguese',
    bg: 'Bulgarian',
    es: 'Español'
  };
  return languageMap[languageCode];
}

export function mapLanguage(language: string): string {
  const languageMap = {
    'English (US)': 'en',
    'Italian': 'it',
    'French': 'fr',
    'Portuguese': 'pt',
    'Bulgarian': 'bg',
    'Español': 'es'
  };
  return languageMap[language];
}

export function mapCountry(countryCode): string {
  const countryMap = {
    AR: 'AR Argentina',
    BO: 'BO Bolivia',
    BR: 'BR Brazil',
    CA: 'CA Canada',
    CL: 'CL Chile',
    CO: 'CO Colombia',
    EC: 'EC Ecuador',
    GP: 'GU Guadeloupe',
    MQ: 'MQ Martinique',
    MX: 'MX Mexico',
    PE: 'PE Peru',
    TT: 'TT Trinidad and Tobago',
    US: 'US United States of America',
    UY: 'UY Uruguay',
    VE: 'VE Venezuela'
  };
  return countryMap[countryCode];
}

export function getCountries(): string[] {
  return [
    'AR Argentina',
    'BO Bolivia',
    'BR Brazil',
    'CA Canada',
    'CL Chile',
    'CO Colombia',
    'EC Ecuador',
    'GP Guadeloupe',
    'MQ Martinique',
    'MX Mexico',
    'PE Peru',
    'TT Trinidad and Tobago',
    'US United States of America',
    'UY Uruguay',
    'VE Venezuela'
  ];
}
